@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../constants/spacing.module.less';
@import (reference) '../../settings-page.module.less';

.additional-carriers-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: @space-32;

  .additional-carriers {
    /* Auto layout */
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: @space-24;
    margin-bottom: 29px;

    width: 578px;

    /* Greys/grey-000 */
    background: #fff;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.05);
    border-radius: 4px;

    .header {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: @space-16;

      .title {
        font-size: 24px;
        line-height: 30px;
        font-weight: 700;
      }

      .description {
        line-height: 20px;
        margin-bottom: 0;
        margin-top: @space-8;
      }
    }

    .tiles {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      flex-flow: row wrap;
      justify-content: center;
      gap: 6px;

      .tile {
        width: 160px;
        height: 118px;
        display: flex;
        cursor: pointer;
        flex-direction: column;
        align-items: center;
        border: 1px solid var(--default--border-color--1);
        border-radius: 4px;
        text-align: center;
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        padding-top: @space-12;
        padding-bottom: @space-8;

        img {
          align-self: center;
          max-width: 64px;
          max-height: 64px;
          height: 64px;
        }

        .provider-name {
          align-self: stretch;
          height: 32px;
          line-height: 15px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }

    .footer {
      display: flex;
      flex-direction: column;
      align-items: center;
      font-weight: 400;
      font-size: 14px;
      line-height: 18px;
      margin-top: 20px;
    }
  }
}

.icon-part {
  cursor: pointer;

  > svg {
    transform: scale(0.6);
    height: 26px;
    width: 26px;
    fill: var(--gold-500);
  }
}

.carrier-table {
  display: grid;
  grid-template-columns:
    3fr
    1fr
    max-content;
  border: @settings-page--table--border;
  font-size: @settings-page--table--font-size;
  line-height: @settings-page--table--line-height;

  &.carrier-table-4-columns {
    grid-template-columns:
      3fr
      1fr
      1fr
      max-content;
  }

  thead,
  tbody,
  tr {
    display: contents;
  }

  th {
    display: flex;
    align-items: center;
    min-height: 18px;
    font-weight: @settings-page--table--header--cell--font-weight;
    background-color: @settings-page--table--header--cell--background-color;
    color: @settings-page--table--header--cell--text-color;
    padding: @settings-page--table--cell--padding;

    &.carrier-id-cell {
      & > div {
        display: flex;
        align-items: center;
        height: 100%;
      }
    }

    &.actions-cell {
      justify-content: center;
    }
  }

  .left-spacer {
    color: var(--default--text-color--15);

    .name-row {
      display: flex;
      align-items: center;
      margin-bottom: 2px;

      & > :first-child {
        font-size: 14px;
        margin-right: @space-4;
        color: var(--default--text-color--16);
      }

      .status-label {
        margin-left: @space-16;
      }
    }

    .details-row {
      display: flex;
      flex-direction: row;
      align-items: center;

      > button {
        margin-left: @space-4;
        font-size: 12px;
      }
    }
  }

  td {
    &.half-opacity {
      opacity: 0.5;
    }
    display: flex;
    align-items: center;
    min-height: 65px;
    border-top: @settings-page--table--border;
    background-color: @settings-page--table--body--cell--background-color;
    color: @settings-page--table--body--cell--text-color;
    padding: @settings-page--table--cell--padding;

    & > div {
      text-align: center;
    }

    &.provider-name-cell {
      grid-column: 1;

      & > div {
        text-align: left;
        display: flex;
        align-items: center;
      }
    }

    &.id-cell {
      & > div {
        display: flex;
        align-items: center;
      }
    }

    &.actions-cell {
      justify-content: center;
    }
  }

  .header-tooltip {
    display: flex;
    margin-left: @space-4;

    .header-icon {
      width: 21px;
      height: 16px;
      color: @inline-message--info--text-color;
    }
  }
}

.table-title {
  display: flex;
  justify-content: space-between;
  margin: @space-24 @space-0 @space-16;
  width: 100%;
  padding: @space-0 @space-24;
}

.small-link {
  font-size: 12px;
}

.icon-wrapper {
  display: flex;
  align-items: center;
  flex-grow: 1;

  .provider-row-logo {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    width: 30px;
    min-width: 30px;
    margin-right: 12px;

    > img {
      height: 100%;
      width: 100%;
    }
  }
}

.loading-balance {
  height: 15px;
  width: 15px;
}

.call-to-action {
  margin-bottom: @space-16;
  height: 40px;
  font-size: 12px;
  display: grid;
  grid-template-columns: auto auto;
  align-items: center;
}

.lock-icon {
  height: 10px;
  margin-right: @space-8;
}

.call-to-action-button-container {
  display: flex;
  justify-content: flex-end;
}

.call-to-action-button {
  justify-self: flex-end;
  display: flex;
  align-items: center;
}

.disclaimer {
  max-width: 490px;
  margin-bottom: @space-16;
}

.disabled-text {
  color: @settings-page--popular--disabled--text-color;
  margin-bottom: 5px;
}

.call-to-action-message {
  font-size: 14px;
}

.popover-wrapper {
  min-width: 150px;
  max-width: 300px;
}

.popover-title {
  padding: @space-12;
  background-color: var(--grey-200);
  border-bottom: 1px solid var(--grey-400);
}

.popover-body {
  padding: @space-12;
}

.text-right {
  margin-left: @space-12;
}

.tooltip-body {
  width: 200px;
}

.empty-carrier-table-body {
  padding: @space-40 @space-16;
  align-items: center;
  justify-content: center;
  grid-column: 1 / -1;
  color: var(--gray-637381);
  background-color: @settings-page--table--body--cell--background-color;
}
